import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _styled from "@emotion/styled-base";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { ErrorMessage, Field } from '@atlaskit/form';
import Select from '@atlaskit/select';
import React from 'react';
import withRepeatField from '../RepeatFormFieldsHOC';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const SelectWrapper = _styled("div", {
  target: "e6wqu8c0",
  label: "SelectWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1ivgbss",
  styles: "width:350px;"
} : {
  name: "1ivgbss",
  styles: "width:350px;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const SelectInput = _ref => {
  let {
    defaultValue,
    placeholder,
    onChange,
    options,
    fieldName,
    validate
  } = _ref;
  const createOption = label => ({
    label,
    value: label
  });
  const updatedOptions = options;
  const getValue = () => {
    if (defaultValue) {
      const initialValueAsExistingOption = options.find(option => option.value === defaultValue);
      if (initialValueAsExistingOption) {
        return initialValueAsExistingOption;
      } else {
        const option = createOption(defaultValue);
        updatedOptions.push(option);
        return option;
      }
    } else {
      return '';
    }
  };
  const handleChange = newValue => {
    onChange(newValue.value);
  };
  return /*#__PURE__*/_jsx(Field, {
    name: fieldName,
    validate: validate,
    defaultValue: defaultValue,
    children: _ref2 => {
      let {
        fieldProps,
        error
      } = _ref2;
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(SelectWrapper, {
          "data-testid": "partnerFormRepeatableSelect",
          children: /*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread({}, fieldProps), {}, {
            placeholder: placeholder,
            onChange: handleChange,
            options: updatedOptions,
            value: getValue(),
            label: "select"
          }))
        }), error && /*#__PURE__*/_jsx(ErrorMessage, {
          children: error
        })]
      });
    }
  });
};
export default SelectInput;
export const RepeatingSelect = withRepeatField(SelectInput);